import React, { useState, useRef, useEffect } from "react";

// @ts-ignore
import { Biscuit, Notification } from "../../utils";

const NewMapOverlay = ({
  locations,
  clientHash,
  clientToken,
  availability,
  language,
}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  //console.log(isModalOpen);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const styles:any = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    },
    modal: {
      backgroundColor: "white",
      padding: "15px",
      borderRadius: "8px",
      //width: "620px",
      //height: "420px",
      width: "100%",
      height: "100%",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "2px",
      right: "2px",
      backgroundColor: "#333",
      border: "0",
      fontSize: "20px",
      cursor: "pointer",
      padding: ".5em",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      color: "white",
      borderRadius: "50%",
      aspectRatio: "1",
      lineHeight: ".7",
      fontWeight: "bold",
    },
    iframe: {
      border: "0px",
      width: "100%",
      height: "100%",
      display: "block" /* iframes are inline by default */,
    },
  };

  const iframeRef = useRef(null);

  const sendMessageToIframe = () => {
    const iframe = iframeRef.current;
    // @ts-ignore
    if (iframe && iframe.contentWindow) {
      const targetOrigin = "http://test-map.inbooma.net?hash="+Biscuit.get('client.hash')+'&token='+Biscuit.get('token')+'&availability='+(availability?'true':'false'); // TODO don't forget to change for production
      //const targetOrigin = "http://localhost:5173/"; // TODO don't forget to change for production
    /*  iframe.contentWindow.postMessage(
        {
          type: "MAP_DATA",
          payload: {
            locations: locations,
            hash: clientHash,
            token: clientToken,
            availability: availability,
            language: language,
          },
        },
        targetOrigin
      );*/
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      sendMessageToIframe();
      //console.log("token from dashboard: ", Biscuit.get("token"));
    }
  }, [isModalOpen, locations, clientHash, clientToken, availability]);


  return (
    <>
      <div
        id="mapOverlay"
        style={{
          position: "relative", //because the button has postion absolute
          zIndex: "200",
        }}
      >
     {/*   <button
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            backgroundColor: "blue",
            color: "white",
            padding: "10px 20px",
            border: "1px solid red",
            cursor: "pointer",
          }}
          onClick={toggleModal}
        >
          Map anzeigen
        </button>*/}
      </div>

      {isModalOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <button onClick={toggleModal} style={styles.closeButton}>
              X
            </button>
            <iframe
              ref={iframeRef}
              src={"http://test-map.inbooma.net?hash="+Biscuit.get('client.hash')+'&token='+Biscuit.get('token')+'&availability='+(availability?'true':'false')}
              width="600"
              //height="400"
              style={styles.iframe}
              title="Map"
              onLoad={sendMessageToIframe}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default NewMapOverlay;
